import React from 'react';
import { useIntl } from 'react-intl';

import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';
import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';

export interface SwitchRuleSuccessScreenProps {
  onClose: () => void;
}

export const SwitchRuleSuccessScreen = ({ onClose }: SwitchRuleSuccessScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'predict.coa.switch_rule_created',
          defaultMessage: 'Switch rule created'
        })}
      />
    </WizardScreen>
  );
};
